import * as React from "react";

import { Blocks, Container, Square, SquareSquare } from "lucide-react";

export const getPlanColorTheme = (tier: string) => {
  switch (tier) {
    case "basic":
      return {
        text: "text-sky-600",
        bg: "bg-sky-50",
        stroke: "text-sky-600",
        borderColor: "border-sky-100",
        cardBorder: "border-sky-50/5",
        cardBg: "bg-sky-500/[0.03]",
      };
    case "standard":
      return {
        text: "text-indigo-600",
        bg: "bg-indigo-50",
        stroke: "text-indigo-500",
        borderColor: "border-indigo-100",
        cardBorder: "border-indigo-500/5",
        cardBg: "bg-indigo-600/5",
      };
    case "growth":
      return {
        text: "text-fuchsia-600",
        bg: "bg-fuchsia-50",
        stroke: "text-fuchsia-500",
        borderColor: "border-fuchsia-100",
        cardBorder: "border-fuchsia-500/5",
        cardBg: "bg-fuchsia-600/[0.02]",
      };
    case "custom":
      return {
        text: "text-orange-600",
        bg: "bg-orange-50",
        stroke: "text-orange-600",
        borderColor: "border-orange-100",
        cardBorder: "border-black/5",
        cardBg: "bg-orange-50/60",
      };
    default:
      return {
        text: "text-info",
        bg: "bg-info-soft",
        stroke: "text-blue-700",
        borderColor: "border-info-soft",
        cardBorder: "border-surface",
        cardBg: "bg-sheet",
      };
  }
};

export const getPlanIcon = (
  tier: string,
  strokeColor: string,
  wrapperClassName: string = "flex items-center justify-center w-10 h-10 rounded-full border border-border bg-sheet shadow-md",
) => {
  const iconWrapper = (icon: React.ReactNode) => (
    <div className={wrapperClassName}>{icon}</div>
  );

  switch (tier) {
    case "basic":
      return iconWrapper(<Square className={strokeColor} size={20} />);
    case "standard":
      return iconWrapper(<SquareSquare className={strokeColor} size={20} />);
    case "growth":
      return iconWrapper(<Blocks className={strokeColor} size={20} />);
    case "custom":
      return iconWrapper(<Container className={strokeColor} size={20} />);
    default:
      return null;
  }
};
